import type { PublicApiKey } from '#packages/apilib';
import type { createLayoutApi } from './createLayoutApi';

export const LayoutApiKey: PublicApiKey<typeof createLayoutApi> = {
  name: 'LayoutApi',
  public: true,
};
